import Cookies from "js-cookie";
import React, { useState, useEffect, createContext } from "react";
import { getUserInfo } from "@/services/api";
import {
  Link,
  Outlet,
  useNavigate,
  useLocation,
  Navigate,
  useOutletContext,
} from "react-router-dom";
import { GAClickPersonalVip } from "@/ga/personCenter";
import { Tabs, Button, message } from "antd";
import api_domain_config from "@/config/config";
import { connect } from "react-redux";
import actions from "@/redux/action";
import store from "../../redux/store";
import "./index.less";
export const context = createContext([]);

/**
 * 个人中心页面
 * @returns
 */
const PersonalCenter = (props) => {
  const [currentUserInfo, setCurrentUserInfo] = useState({});
  const [listLoading, setListLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  /**
   * 当前选中的tab
   */
  const [tabActiveKey, setTabActiveKey] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    //获取当前路由路径
    let pathname = location.pathname;
    let key = pathname.includes("product-info")
      ? "person_vip"
      : pathname.includes("personal-info")
      ? "person_info"
      : pathname.includes("product-list")
      ? "my_products"
      : "my_orders";
    setTabActiveKey(key);
  }, [location.pathname]);

  useEffect(() => {
    getCurrentUserInfo();
    /**
     * 判断当前系统
     */
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);

  /**
   * 获取用户信息
   */
  const getCurrentUserInfo = async () => {
    setListLoading(true);
    try {
      const { code, data } = await getUserInfo();
      if (code === 200) {
        //保存当前的用户信息
        localStorage.setItem("currentUserInfo", JSON.stringify(data));
        setCurrentUserInfo(data);
        setListLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * 切换tab事件
   * @param {String} key
   */
  const onTabChange = (key) => {
    switch (key) {
      case "my_products":
        navigate("/personal-center/product-list", { replace: true });
        break;
      case "my_orders":
        navigate("/personal-center/order-list", { replace: true });
        break;
      case "person_info":
        navigate("/personal-center/personal-info", { replace: true });
        break;
      case "person_vip":
        navigate("/personal-center/product-info", { replace: true });
        break;
      default:
        break;
    }
  };

  const tabItems = [
    {
      key: "my_products",
      label: `我的产品`,
    },
    {
      key: "my_orders",
      label: `我的订单`,
    },
    {
      key: "person_info",
      label: `个人信息`,
    },
    {
      key: "person_vip",
      label: `开通VIP`,
    },
  ];

  return (
    <>
      <div className="person-center">
        <div className="topContent text-center">
          <h1 className="text-white mb-0 fw-bold">个人中心</h1>
        </div>
        <div className="section-page bg-light">
          <div className="container">
            <div className="paerson-content">
              <div className="person-content-page rounded-3 d-lg-flex flex-lg-row">
                <div className="lft d-flex flex-column text-center">
                  <div className="lft-top">
                    <img
                      src={
                        currentUserInfo?.head_pic ||
                        "https://images.niuxuezhang.cn/imgs/account-center/user.svg"
                      }
                      alt=""
                      width={64}
                      height={64}
                      className="mx-auto"
                      style={{ borderRadius: "50%" }}
                    />
                    <div className="mt-2 desc username">
                      {currentUserInfo?.nickname}
                    </div>
                    <div className="text-center">
                      <Link
                        to="/personal-center/product-info"
                        className="btn btn-primary btn-sm btn-vip mt-3 rounded-1 fw-normal d-inline-block"
                        onClick={GAClickPersonalVip}
                      >
                        开通VIP
                      </Link>
                    </div>
                  </div>
                  <div className="tab-list position-relative">
                    <Tabs
                      tabPosition={isMobile ? "top" : "left"}
                      className="tabs"
                      onChange={onTabChange}
                      items={tabItems}
                      activeKey={tabActiveKey}
                    />
                  </div>
                </div>
                <div className="rgt overflow-hidden flex-fill position-relative">
                  {/* <context.Provider value={{ currentUserInfo }}> */}
                  <Outlet
                    context={{
                      getCurrentUserInfo,
                      currentUserInfo,
                      listLoading,
                    }}
                  />
                  {/* </context.Provider> */}
                  {tabActiveKey === "my_products" && (
                    <p
                      className="mb-0 text-muted tiny"
                      style={{
                        position: "absolute",
                        bottom: "24px",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    >
                      如购买的是注册码产品，请点击
                      <a
                        href="https://www.niuxuezhang.cn/support/retrieve-license-code.html"
                        target="_brank"
                        className="text-decoration-underline"
                      >
                        注册码页面
                      </a>
                      查询对应产品信息。
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalCenter;
